import { render, staticRenderFns } from "./service-type.vue?vue&type=template&id=6bad6ab4&scoped=true&"
import script from "./service-type.vue?vue&type=script&lang=js&"
export * from "./service-type.vue?vue&type=script&lang=js&"
import style0 from "./service-type.vue?vue&type=style&index=0&id=6bad6ab4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bad6ab4",
  null
  
)

export default component.exports